/**
 * Import and instantiate front end modules
 */
import GLightbox from 'glightbox';

import {updateBodyClassname} from './core/body';
import iconSystem from './core/icon-system';
import location from './core/location';
import navigation from './core/navigation';
import productInformationTabs from './core/product-information-tabs';
import hero from './core/hero';
import contentSlider from './core/content-slider';
import tabbedContent from './core/tabbed-content';
import headlineStyling from "./core/headline-styling";
import resourceDownloads from "./core/resource-downloads";

updateBodyClassname();
navigation();
iconSystem();
location();
productInformationTabs();
hero();
contentSlider();
tabbedContent();
headlineStyling()
resourceDownloads();

const lightbox = GLightbox({
	touchNavigation: true,
	loop: true,
});
